import { Component, OnInit } from '@angular/core';
import { User } from '../../../shared/user/user.model';
import { Globals } from '../../../global';
import { ClientService } from '../../../services/client.service';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-user-detail',
	templateUrl: './user-detail.component.html',
	styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
	public user: User;
	public event: any;
	public userData: any;
	public roles: any = [];
	public loggedUserRole: string;
	public clients: any = [];
	public clientsNames: any = [];
	public selectedClient: any = '';

	public clientsFieldAssigment: { fields: string, ids: string }[] = [];
	public clientsFieldRequired: boolean = false;

	constructor(private clientService: ClientService, private userService: UserService, private globals: Globals, private router: Router) {
		this.loggedUserRole = JSON.parse(localStorage.getItem('user')).data.role;
	}

	save() {
		this.user.options.assignByFields.options.customer = this.clientsFieldAssigment;
		const body = {
			_id: this.user._id,
			firstName: this.user.firstName,
			lastName: this.user.lastName,
			role: this.user.role,
			client: this.user.client,
			active: this.user.options.active,
			options: this.user.options,
			customAssignmentId: null
		}

		if(this.user.role === "sales"){
			body.customAssignmentId = this.user.customAssignmentId;
		}

		if (this.user.email !== this.userData.email) {
			body['email'] = this.user.email;
		}

		if (this.user.phone !== this.userData.phone) {
			body['phone'] = this.user.phone;
		}

		this.userService.updateOther(body)
			.subscribe((data: any) => {
				if (data.success) {
					if (this.loggedUserRole == 'manager') {
						this.router.navigate(['/users/sales']);
					} else {
						this.router.navigate(['/users']);
					}
				} else {
					alert('Ocurrió un error, revise que todos los campos sean correctos');
				}
			})
	}

	addFieldAssigment(type: String) {
		switch (type) {
			case 'client':
				this.clientsFieldAssigment.push({ fields: '', ids: '' });
				break;
			case 'campaign':
				break;
			case 'form':
				break;
			default:
				break;
		}
	}

	setClient(index: number, client: string) {
		this.clientsFieldAssigment[index].ids = client;
	}

	removeFieldAssigment(type: String, index: number) {
		switch (type) {
			case 'client':
				this.clientsFieldAssigment.splice(index, 1);
				if (this.clientsFieldAssigment.length == 0) this.clientsFieldRequired = false;
				break;
			case 'campaign':
				break;
			case 'form':
				break;
			default:
				break;
		}
	}

	getUserInfo() {
		if (localStorage.getItem('userInfo')) {
			this.user = new User().deserialize(JSON.parse(localStorage.getItem('userInfo')));
			this.userData = new User().deserialize(JSON.parse(localStorage.getItem('userInfo')));
			this.clientsFieldAssigment = this.user.options.assignByFields.options.customer;
			if (this.clientsFieldAssigment.length > 0) this.clientsFieldRequired = true;
		}
	}

	getClients() {
		if (this.loggedUserRole !== 'manager') {
			this.clientService.getAll()
				.subscribe((response: any) => {
					this.clients = response.data;
					this.user.client.map((a) => {
						this.clients.map((b) => {
							if (a == b._id) { this.clientsNames.push(b); }
						});
					});
				});
		}
	}

	openMyModal(event) {
		document.querySelector("#" + event).classList.add('md-show');
		this.event = event;
	}

	addClient() {
		let isAssigned = false;
		this.user.client.map((x) => {
			if (x == this.selectedClient._id) {
				isAssigned = true;
			}
		});
		if (!isAssigned) {
			this.user.client.push(this.selectedClient._id);
			this.clientsNames.push(this.selectedClient);
		}
	}

	removeClient(item: any) {
		this.user.client = this.user.client.filter((x) => { return x !== item._id });
		this.clientsNames = this.clientsNames.filter((x) => { return x.name !== item.name });
	}

	ngOnInit() {
		this.getUserInfo();
		this.getClients();
		this.roles = this.globals.roles;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/users/user-detail/user-detail.component.ts